var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaq(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C5.03412 0 1 3.81 1 8.5C1 13.19 5.03412 17 10 17H10.5294V20C15.6753 17.66 19 13 19 8.5C19 3.81 14.9659 0 10 0ZM11.0588 14.5H8.94118V12.5H11.0588V14.5ZM11.4824 9.72C11.4718 9.73 11.4612 9.75 11.4506 9.77C11.3976 9.85 11.3447 9.93 11.3024 10.01C11.2812 10.04 11.2706 10.08 11.26 10.12C11.2282 10.19 11.1965 10.26 11.1753 10.33C11.1012 10.54 11.0694 10.76 11.0694 11.01H8.94118C8.94118 10.5 9.02588 10.07 9.15294 9.71C9.15294 9.7 9.15294 9.69 9.16353 9.68C9.17412 9.64 9.20588 9.62 9.21647 9.58C9.28 9.42 9.35412 9.28 9.44941 9.14C9.48118 9.09 9.52353 9.04 9.55529 8.99C9.58706 8.95 9.60824 8.9 9.64 8.87L9.65059 8.88C10.54 7.78 11.9906 7.44 12.1071 6.2C12.2024 5.22 11.4612 4.27 10.4447 4.07C9.34353 3.85 8.34824 4.46 8.00941 5.35C7.86118 5.71 7.51176 6 7.07765 6H6.86588C6.23059 6 5.76471 5.41 5.94471 4.83C6.24139 3.91042 6.87865 3.12243 7.73994 2.61013C8.60123 2.09783 9.629 1.89545 10.6353 2.04C12.4247 2.29 13.8541 3.68 14.1612 5.37C14.6271 7.81 12.4353 8.4 11.4824 9.72Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.0f67b20d11c21a8552ce4b08d161e703.svg";
export { ForwardRef as ReactComponent };